import styled, { css } from 'styled-components'
import ButtonComponent from '../../button'

export const Button = styled(ButtonComponent)<{ active?: boolean }>`
    border-radius: inherit;
    min-width: auto;
    width: 100%;

    ${({ active }) =>
        active &&
        css`
            transition: all 0.15s ease-out;
        `}
`

export const Options = styled.div`
    border-radius: inherit;
    display: flex;
    flex-direction: row;
`
